import {
    PrincipalData,
    VisitsRepartitionData,
    GroupsRepartitionData,
    TimePassedInStoreData,
} from '@app/models';

export interface BucketData {
    countingDatasByType: ChartApi;
    kpiData: CountingApiData;
    kpiDataAdapt: CountingApiData;
    repartitonAttendanceTime: RepartitionTimeApi;
    averageAllTimeSpend: number;
    averageEntry: number;
    averageEntryGroup: number;
    attractivityEnabled: boolean;
    groupsCountingEnabled: boolean;
    financialDataEnabled: boolean;
    attractivityWifi: number;
    wifiPassage: number;
    principalData: PrincipalData;
    visitsRepartitionData: VisitsRepartitionData;
    groupsRepartitionData: GroupsRepartitionData;
    timePassedInStoreData: TimePassedInStoreData;
}

export interface CountingData {
    [key: string]: any;
    timespent?: number;
    wifiVisits?: number;
    wifiPassages?: number;
    averageWifiPassages?: number;
    averageWifiVisits?: number;
    averageCustomers?: number;
    customers?: number;
    customersGroup?: number;
    ca?: number;
    ticket?: number;
    videoPassagesGroup?: number;
    videoGroupVisits?: number;
    videoPassages?: number;
    videoVisits?: number;
    passages?: number;
    visits?: number;
    attractivity?: number; // only front, not comming from backend
    attractivenessRate: number;
    transformRate: number;
}

export interface CountingApiData {
    current: CountingData;
    versus: CountingData;
}

export interface ChartApi {
    localBusiness: ChartApiLocalBusiness;
    current: ChartApiCurrent;
    versus: ChartApiVersus;
    opts: ChartApiOpts;
}

export interface RepartitionTimeApi {
    current: {
        count1To5: string;
        count5To10: string;
        count10To20: string;
        count20To30: string;
        count30AndMore: string;
    };
    versus: {
        count1To5: string;
        count5To10: string;
        count10To20: string;
        count20To30: string;
        count30AndMore: string;
    };
    label: [];
}

export interface ChartRepartitionApi {
    current: {
        count1To5: string;
        count5To10: string;
        count10To20: string;
        count20To30: string;
        count30AndMore: string;
    };
    versus: {
        count1To5: string;
        count5To10: string;
        count10To20: string;
        count20To30: string;
        count30AndMore: string;
    };
}
export interface ChartApiLocalBusiness {
    id: number;
    legalName: string;
    timezone: string;
    organization: number;
    enabled: boolean;
    zipcode: string;
    city: string;
    attractivityEnabled: boolean;
    groupsCountingEnabled: boolean;
}

export interface ChartApiCurrent {
    label: string[];
    ca: number[];
    ticket: number[];
    entry: number[];
    entryGroup: number[];
    transformRate: any[];
    averageAllTimeSpend: number;
    averageEntry: number;
    averageEntryGroup: number;
    entryFrequency: number[];
    labelFrequency: number[];
}

export interface ChartApiVersus {
    label: string[];
    ca: number[];
    ticket: number[];
    entry: number[];
    entryGroup: number[];
    transformRate: any[];
    averageAllTimeSpend: number;
    averageEntry: number;
    averageEntryGroup: number;
    entryFrequency: number[];
    labelFrequency: number[];
}

export interface ChartApiOpts {
    showFinancial: boolean;
    showGroup: boolean;
}
